const map = {
	"./careers/Bars.svg": 205,
	"./careers/Book.svg": 388,
	"./careers/Send.svg": 497,
	"./careers/Shield.svg": 84,
	"./careers/Star.svg": 679,
	"./careers/robot.png": 447,
	"./icons/alimentacion.png": 140,
	"./icons/i1.png": 52,
	"./icons/i10.png": 86,
	"./icons/i11.png": 663,
	"./icons/i12.png": 556,
	"./icons/i13.png": 445,
	"./icons/i14.png": 570,
	"./icons/i15.png": 427,
	"./icons/i2.png": 543,
	"./icons/i3.png": 526,
	"./icons/i4.png": 921,
	"./icons/i5.png": 672,
	"./icons/i6.png": 963,
	"./icons/i7.png": 834,
	"./icons/i8.png": 365,
	"./icons/i9.png": 476,
	"./icons/rvoe.svg": 142,
	"./icons/sep.svg": 750,
	"./icons/vline.svg": 94,
	"./main/about.webp": 882,
	"./main/aula-logo.jpeg": 253,
	"./main/awrapper.webp": 559,
	"./main/bg.webp": 226,
	"./main/close.svg": 517,
	"./main/logo.png": 688,
	"./main/menu.svg": 18,
	"./main/wa.png": 177,
	"./testimonial_people/tp1.webp": 806,
	"./testimonial_people/tp2.webp": 143,
	"./testimonial_people/tp3.webp": 964
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 272;